if (!customElements.get("collapsible-product")) {
  class CollapsibleProduct extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector("[data-trigger]");
      this.panel = this.querySelector("[data-content]");
      if (!this.trigger || !this.panel) return;

      this.isOpen = this.getAttribute("open") === "true";
      this.reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.onToggle = this.toggle.bind(this);
      this.onTransitionEnd = this.handleTransitionEnd.bind(this);

      this.trigger.addEventListener("click", this.onToggle);
      this.panel.addEventListener("transitionend", this.onTransitionEnd);

      this.panel.hidden = false;
      this.panel.style.overflow = "hidden";

      if (this.isOpen) {
        this.classList.add("is-expanded");
        this.trigger.setAttribute("aria-expanded", "true");
        this.panel.style.height = "auto";
      } else {
        this.classList.remove("is-expanded");
        this.trigger.setAttribute("aria-expanded", "false");
        this.panel.style.height = "0px";
      }
    }

    disconnectedCallback() {
      if (this.trigger) this.trigger.removeEventListener("click", this.onToggle);
      if (this.panel) this.panel.removeEventListener("transitionend", this.onTransitionEnd);
    }

    toggle(event) {
      event.preventDefault();
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    }

    open() {
      this.isOpen = true;
      const startHeight = this.panel.getBoundingClientRect().height;
      this.panel.style.height = startHeight + "px";
      this.setAttribute("open", "true");
      this.classList.add("is-expanded");
      this.trigger.setAttribute("aria-expanded", "true");

      if (this.reduceMotion) {
        this.panel.style.height = "auto";
        return;
      }

      this.panel.offsetHeight;
      this.panel.style.height = this.panel.scrollHeight + "px";
    }

    close() {
      this.isOpen = false;
      const startHeight = this.panel.getBoundingClientRect().height;
      this.panel.style.height = startHeight + "px";
      this.removeAttribute("open");
      this.classList.remove("is-expanded");
      this.trigger.setAttribute("aria-expanded", "false");

      if (this.reduceMotion) {
        this.panel.style.height = "0px";
        return;
      }

      this.panel.offsetHeight;
      this.panel.style.height = "0px";
    }

    handleTransitionEnd(event) {
      if (event.target !== this.panel || event.propertyName !== "height") return;

      if (this.isOpen) {
        this.panel.style.height = "auto";
      }
    }
  }

  customElements.define("collapsible-product", CollapsibleProduct);
}
